import {ContentWaitfreeInfo} from '../generated/types';

export function createContentWaitfreeInfo({
  user_activation,
  charged_at,
  charged_complete,
  charged_period_by_minute,
}: {
  user_activation?: boolean;
  charged_at?: string;
  charged_complete?: boolean;
  charged_period_by_minute?: number;
}): ContentWaitfreeInfo {
  return {
    activation: !!user_activation,
    chargedAt: charged_at,
    baseDate: new Date().toISOString(),
    chargedComplete: !!charged_complete,
    chargedPeriodByMinute: charged_period_by_minute,
  };
}
